import api from '../api';

const roleApi = {
  // Lấy tất cả roles
  getAllRoles: async (token) => {
    try {
      const response = await api.get('/admin/roles/', {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Tạo role mới
  createRole: async (token, roleData) => {
    try {
      console.log(roleData);
      const response = await api.post('/admin/roles/', roleData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Cập nhật role
  updateRole: async (token, roleId, roleData) => {
    try {
      const response = await api.put(`/admin/roles/${roleId}`, roleData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Xóa role
  deleteRole: async (token, roleId) => {
    try {
      const response = await api.delete(`/admin/roles/${roleId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Lấy role theo ID
  getRoleById: async (token, roleId) => {
    try {
      const response = await api.get(`/admin/roles/${roleId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default roleApi; 
